import { omit } from 'lodash-es';
import { handleActions } from 'redux-actions';

import { Actions } from './Actions';

const initialState = {};

export default handleActions(
  {
    [Actions.INIT_STATE]: (state, action) => ({
      ...state,
      [action.payload]: {
        selectedJobCategory: {
          loading: false,
          value: null,
          error: null,
        },
        options: {
          loading: false,
          value: [],
          error: null,
        },
      },
    }),
    [Actions.DESTROY_STATE]: (state, action) => ({
      ...omit(state, action.payload),
    }),
    [Actions.SELECTED_JOB_CATEGORY_REQUEST]: (state, action) => ({
      ...state,
      [action.meta.form]: {
        ...state[action.meta.form],
        selectedJobCategory: {
          ...state.selectedJobCategory,
          loading: true,
          value: null,
          error: null,
        },
      },
    }),
    [Actions.SELECTED_JOB_CATEGORY_SUCCESS]: (state, action) => ({
      ...state,
      [action.meta.form]: {
        ...state[action.meta.form],
        selectedJobCategory: {
          ...state.selectedJobCategory,
          loading: false,
          value: action.response.result,
          error: null,
        },
      },
    }),
    [Actions.SELECTED_JOB_CATEGORY_FAILURE]: (state, action) => ({
      ...state,
      [action.meta.form]: {
        ...state[action.meta.form],
        selectedJobCategory: {
          ...state.selectedJobCategory,
          loading: false,
          value: null,
          error: action.payload,
        },
      },
    }),
    [Actions.UPDATE_SELECTED_JOB_CATEGORY]: (state, action) => ({
      ...state,
      [action.meta.form]: {
        ...state[action.meta.form],
        selectedJobCategory: {
          ...state.selectedJobCategory,
          loading: false,
          value: action.payload,
          error: null,
        },
      },
    }),
    [Actions.JOB_CATEGORIES_REQUEST]: (state, action) => ({
      ...state,
      [action.meta.form]: {
        ...state[action.meta.form],
        options: {
          ...state.options,
          loading: true,
          value: [],
          error: null,
        },
      },
    }),
    [Actions.JOB_CATEGORIES_SUCCESS]: (state, action) => ({
      ...state,
      [action.meta.form]: {
        ...state[action.meta.form],
        options: {
          ...state.options,
          loading: false,
          value: action.response.result,
          error: null,
        },
      },
    }),
    [Actions.JOB_CATEGORIES_FAILURE]: (state, action) => ({
      ...state,
      [action.meta.form]: {
        ...state[action.meta.form],
        options: {
          ...state.options,
          loading: false,
          value: [],
          error: action.payload,
        },
      },
    }),
  },
  initialState
);
